// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Kkws","type":"styles_type__fHxAu","choices":"styles_choices__3spe9"};